var __extends = this && this.__extends || function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
import * as fetch from 'isomorphic-fetch';
import { BffSource } from 'bernie-core';
var LoyaltySource = /** @class */function (_super) {
  __extends(LoyaltySource, _super);
  function LoyaltySource(logger) {
    return _super.call(this, '', logger, {}, {}) || this;
  }
  LoyaltySource.prototype.fetch = function (options) {
    var _a = options.context,
      id = _a.site.id,
      locale = _a.locale;
    var tuid = options.tuid;
    var url = "".concat(this.host, "/gc/memberDetails/").concat(id, "/").concat(tuid, "/").concat(locale);
    return fetch(url, {
      method: 'GET'
    }).then(function (res) {
      return res.json().then(function (response) {
        return {
          loyalty: response
        };
      });
    });
  };
  return LoyaltySource;
}(BffSource);
export { LoyaltySource };